import React, { useContext, useEffect } from "react";
import { motion } from "framer-motion";
import { IDocumentListView } from "./Interface/IDocumentListView";
import { useDocuments } from "../Hooks/DocumentsContext";
import { LanuageContext } from "../Hooks/LanguageContext";
import { IDocumentModel } from "../Models/DocumentManifestModel";
import { useNavigate } from "react-router-dom";
import "./Styles/DocumentListView.scss";

const DocumentListView: React.FC<IDocumentListView> = (props) => {
  const langugage = useContext(LanuageContext);
  const { state, initializeDocuments } = useDocuments();

  const navigate = useNavigate();

  useEffect(() => {
    const loadDocuments = async () => {
      try {
        if (state.documents.length === 0 && !state.loading) {
          console.log("Initializing documents for language:", langugage);
          await initializeDocuments(langugage);
        }
      } catch (error) {
        console.error("Failed to initialize documents:", error);
      }
    };

    loadDocuments();
  }, []);

  const onTapped = (doc: IDocumentModel) => {
    navigate("/doc?id=" + encodeURIComponent(doc.id));
  };

  return (
    <motion.div className="DocumentListViewWrapper">
      <h1 className="DocumentListViewTitle">Dostupné dokumenty</h1>
      <table className="DocumentListViewTable">
        <thead>
          <tr>
            <th>Název dokumentu</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {state.documents.map((doc) => (
            <tr key={doc.file}>
              <motion.td>
                <motion.span>{doc.title}</motion.span>
              </motion.td>
              <motion.td className="DocumentListViewOpenButtonWrapper">
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.99 }}
                  className="DocumentListViewOpenButton"
                  onTap={() => onTapped(doc)}
                >
                  Otevřít
                </motion.button>
              </motion.td>
            </tr>
          ))}
        </tbody>
      </table>
    </motion.div>
  );
};

export default DocumentListView;
